import { render, staticRenderFns } from "./ProductListForRecommend.vue?vue&type=template&id=a74cdb5c&scoped=true"
import script from "./ProductListForRecommend.vue?vue&type=script&lang=js"
export * from "./ProductListForRecommend.vue?vue&type=script&lang=js"
import style0 from "./ProductListForRecommend.vue?vue&type=style&index=0&id=a74cdb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74cdb5c",
  null
  
)

export default component.exports